/* tslint:disable */

declare var Object: any;
export interface AutologinInterface {
  "id"?: number;
}

export class Autologin implements AutologinInterface {
  "id": number;
  constructor(data?: AutologinInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Autologin`.
   */
  public static getModelName() {
    return "Autologin";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Autologin for dynamic purposes.
  **/
  public static factory(data: AutologinInterface): Autologin{
    return new Autologin(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Autologin',
      plural: 'Autologin',
      path: 'Autologin',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Autologin.ts